import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "photo" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = { class: "photo-info" }
const _hoisted_4 = { class: "date" }


import errorSrc from "@/assets/logo_256x256.jpg";
import loadingSrc from "@/assets/logo_640x480.jpg";

// 组件的属性

/* const props =  */ 
export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoFrame',
  props: {
    src: {
        type: String,
        required: true,
    },
    alt: {
        type: String,
        default: "photo",
    },
    title: {
        type: String,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("img", { alt: __props.alt }, null, 8, _hoisted_2), [
      [_directive_lazy, { src: __props.src, error: _unref(errorSrc), loading: _unref(loadingSrc) }]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.alt), 1),
      _createTextVNode(" " + _toDisplayString(__props.title), 1)
    ])
  ]))
}
}

})